<div [ngClass]="open ? 'searchFilter slide-bottom' : 'slide-top searchFilter'">
  <!-- *ngIf="open" -->

  <div class="row rowM">
    <form [formGroup]="form" class="row">
      <div class="col-6 center">
        <mat-form-field class="matform" appearance="outline">
          <mat-label> Ip</mat-label>
          <input matInput type="text" formControlName="ip" />
        </mat-form-field>
      </div>
      <div class="col-6 center">
        <mat-form-field class="matform" appearance="outline">
          <mat-label> Id Usuario</mat-label>
          <input matInput type="text" formControlName="user" />
        </mat-form-field>
      </div>
      <div class="col-6 center">
        <mat-form-field class="matform" appearance="outline">
          <mat-label>Rol</mat-label>
          <mat-select formControlName="role">
            <mat-option *ngFor="let role of roles" [value]="role.name">{{
              role.name
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-6 center">
        <mat-form-field class="matform" appearance="outline">
          <mat-label>Acción</mat-label>
          <mat-select formControlName="action">
            <mat-option *ngFor="let action of actions" [value]="action.value">{{
              action.key
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-6 center">
        <mat-form-field appearance="outline">
          <mat-label>Fecha/Hora inicio</mat-label>
          <input
            matInput
            formControlName="start"
            type="datetime-local"
            [max]="form.value.end"
          />
          <!-- <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker> -->
        </mat-form-field>
      </div>
      <div class="col-6 center">
        <mat-form-field appearance="outline">
          <mat-label>Fecha/Hora final</mat-label>
          <input
            [disabled]="!form.value.start"
            matInput
            formControlName="end"
            type="datetime-local"
            [min]="form.value.start"
          />
          <!-- <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker> -->
        </mat-form-field>
      </div>
      <!-- <div class="col-12 action">
        <mat-form-field class="matform" appearance="outline">
          <mat-label> Acción</mat-label>
          <textarea matInput formControlName="action"></textarea>
        </mat-form-field>
      </div> -->
    </form>
    <div class="col-6 right">
      <button
        [disabled]="!form.valid"
        mat-button
        class="primary-btn"
        (click)="search()"
      >
        Buscar
      </button>
    </div>
    <div class="col-6 left">
      <button mat-button class="primary-btn res" (click)="cleanFilter()">
        Restablecer
      </button>
    </div>
  </div>
</div>
